import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowTitle = _resolveComponent("WindowTitle")!
  const _component_Green = _resolveComponent("Green")!
  const _component_WindowContent = _resolveComponent("WindowContent")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createBlock(_component_Window, { class: "dashboard-hosting" }, {
    default: _withCtx(() => [
      _createVNode(_component_WindowTitle, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Hosting ")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_WindowContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                  _createElementVNode("a", { href: "https://freeside.ltd" }, "freeside.ltd")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("LIVE")
                    ])),
                    _: 1,
                    __: [1]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                  _createElementVNode("a", { href: "https://industries.freeside.ltd" }, "industries.freeside.ltd")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("LIVE")
                    ])),
                    _: 1,
                    __: [3]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                  _createElementVNode("a", { href: "https://webmail.freeside.ltd" }, "webmail.freeside.ltd")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("LIVE")
                    ])),
                    _: 1,
                    __: [5]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                  _createElementVNode("a", { href: "https://situation.freeside.ltd" }, "situation.freeside.ltd")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("LIVE")
                    ])),
                    _: 1,
                    __: [7]
                  })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}